import PATH_NAMES from 'routes/paths';

import type { NavItem } from './types';

export const GLOBAL_NAV_ITEMS: NavItem[] = [
  {
    id: 'accounts',
    label: 'Accounts',
    children: [
      { id: 'accounts-roles', label: 'Roles', href: PATH_NAMES.accounts.roles },
      { id: 'accounts-orgs', label: 'Organizations', href: PATH_NAMES.accounts.organization },
    ],
  },
  {
    id: 'customer',
    label: 'Customer',
    children: [
      { id: 'customer-org', label: 'Organization', href: PATH_NAMES.customer.organization },
    ],
  },
  { id: 'profile', label: 'Profile', href: PATH_NAMES.profile.root },
];

